<template>
    <div class="pl10 mt20" style="word-break: break-all;">
        <div v-if="control.loginType == 1" class="pr10 mb10" align="right">
            <el-table :data="records" border v-if="records.length>0" >
                <el-table-column label="供应商编号" min-width="200" align="center" prop="supplierCode">
                </el-table-column>
                <el-table-column prop="supplierName" label="供应商名称" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="status" label="当前状态" min-width="100" align="center">
                    <template scope="scope">
                        <!--装填判断-->
                        <span>{{scope.row.supplierStatusName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="修改原因" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="auditRemark" label="审核备注" min-width="200" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="100" align="center">
                    <template scope="scope">
                        <el-button  type="text" @click="editBasicInfoData(scope.row.id)" size="small">{{scope.row.status == 1 || scope.row.status == 4 ? '编辑' : '查看'}}</el-button>
                        <el-button v-if="scope.row.status == 1 || scope.row.status == 4" type="text" size="small" @click="deleteRecord(scope.row.id,scope.row.status)">{{scope.row.status == 1 ? '删除' : '取消'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-button type="primary" @click="editBasicInfoData(0)" v-if="records.length == 0">修改供应商信息</el-button>
        </div>

        <span class="dib">基础信息</span><span class="line"></span>
        <div class="mb20">
            <el-form :model="basicForm" ref="basicForm" label-width="207px" class="demo-ruleForm">
                <!-- 基础信息 -->
                <el-row class="mt20">
                    <el-col :span="2" :offset="2">
                        <div class="grid-content">
                            <!-- <span class="main_word mr4">*</span> -->
                            <span class="form_color">供应商编号：</span>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="grid-content">
                            {{ basicForm.suppliersCode }}
                        </div>
                    </el-col>
                </el-row>

                <el-row class="mt20">
                    <el-col :span="2" :offset="2">
                        <div class="grid-content">
                            <!-- <span class="main_word mr4">*</span> -->
                            <span class="form_color">供应商名称：</span>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="grid-content">
                            {{ basicForm.suppliersName }}
                        </div>
                    </el-col>
                </el-row>

                <el-row class="mt20">
                    <el-col :span="2" :offset="2">
                        <div class="grid-content">
                            <!-- <span class="main_word mr4">*</span> -->
                            <span class="form_color">办公地址：</span>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="grid-content">
                            <span>{{ basicForm.officeCountryName }}</span>
                            <span>{{ basicForm.officeProvinceName }}</span>
                            <span>{{ basicForm.officeCityName }}</span>
                            <span>{{ basicForm.officeDistrictName }}</span>
                            <span>{{ basicForm.officeAddress }}</span>
                        </div>
                    </el-col>
                </el-row>

                <!-- 供应商资质信息 -->
                <span class="dib">供应商资质信息</span><span class="second_line"></span>
                <!-- 出版社经营许可证电子版 -->
                <span class="main_word mr4"></span>
                <!-- 注册登记地址 -->
                <el-form-item v-if="basicForm.categoryIsBook !=1 "  label="公司注册地址：">
                    <span>{{ basicForm.registeredCountryName }}</span>
                    <span>{{ basicForm.registeredProvinceName }}</span>
                    <span>{{ basicForm.registeredCityName }}</span>
                    <span>{{ basicForm.registeredDistrictName }}</span>
                    <span>{{ basicForm.registeredAddress }}</span>
                </el-form-item>


                <el-form-item label="品类合作类型：">
                    <el-checkbox-group class="dib vtb ml_10" v-model="categoryType">
                        <el-checkbox label="1" disabled>图书类</el-checkbox>
                        <el-checkbox label="2" disabled>非图书类</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item  v-if="basicForm.categoryIsBook ==1 " label="出版社经营许可证电子版：" class="dib mt20">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" :src="basicForm.publicationBusinessLicenseFile">
                    </div>
                </el-form-item>
                <!-- 注册登记名称 -->
                <el-form-item label="注册登记名称：">
                    <span>{{ basicForm.registeredName }}</span>
                </el-form-item>

                <!-- 注册登记地址 -->
                <el-form-item v-if="basicForm.categoryIsBook ==1 " label="注册登记地址：">
                    <span>{{ basicForm.registeredCountryName }}</span>
                    <span>{{ basicForm.registeredProvinceName }}</span>
                    <span>{{ basicForm.registeredCityName }}</span>
                    <span>{{ basicForm.registeredDistrictName }}</span>
                    <span>{{ basicForm.registeredAddress }}</span>
                </el-form-item>

                <!-- 注册资金 -->
                <el-form-item label="注册资金：">
                    <span>{{ basicForm.registeredCapital }}（单位：万）</span>
                    <span v-if="basicForm.registeredCapitalType == 1">人民币</span>
                    <span v-if="basicForm.registeredCapitalType == 2">美元</span>
                </el-form-item>

                <!-- 执照类型 -->
                <el-form-item label="执照类型："  v-show="basicForm.licenseType !=3 ">
                    <span v-if="basicForm.licenseType == 1">普通营业执照</span>
                    <span v-if="basicForm.licenseType == 2">三证合一／五证合一</span>
                </el-form-item>

                <!-- 注册登记电话： -->
                <!--<el-form-item label="注册登记电话：">-->
                    <!--<span>{{ basicForm.registeredPhone }}</span>-->
                <!--</el-form-item>-->

                <!-- 营业执照号 -->
                <el-form-item label="营业执照号：">
                    <span>{{ basicForm.businessLicenseCode }}</span>
                </el-form-item>

                <!-- 营业执照电子版 -->
                <el-form-item label="营业执照电子版：">
                    <div>
                        <img v-if="basicForm.businessLicenseFile" @click="previewPic($event)" class="pic_skan" :src="basicForm.businessLicenseFile">
                    </div>
                </el-form-item>

                <!-- 执照有限期 -->
                <el-form-item v-show="basicForm.registeredCountry == 1" label="执照有效期：">
                    <span v-if="basicForm.businessLicenseStartDate">{{ basicForm.businessLicenseStartDate | time}}</span> --
          	        <span v-if="basicForm.businessLicenseEndDate">{{ basicForm.businessLicenseEndDate | time}}</span>
                </el-form-item>

                <!-- 组织机构代码 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="组织机构代码：">
                    <span v-if="basicForm.orgCode">{{ basicForm.orgCode }}</span>
                </el-form-item>

                <!-- 组织结构代码电子版 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="组织结构代码电子版：">
                    <div>
                        <img v-if="basicForm.orgCodeFile" @click="previewPic($event)" class="pic_skan" :src="basicForm.orgCodeFile">
                    </div>
                </el-form-item>

                <!-- 税务登记证电子版 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="税务登记证电子版：" >
                    <div>
                        <img v-if="basicForm.taxFile" @click="previewPic($event)" class="pic_skan" :src="basicForm.taxFile">
                    </div>
                </el-form-item>

                <!-- 开户许可证电子版 -->
                <el-form-item label="开户许可证电子版：">
                    <div>
                        <img v-if="basicForm.accountOpeningPermitFile" @click="previewPic($event)" class="pic_skan" :src="basicForm.accountOpeningPermitFile">
                    </div>
                </el-form-item>

                <!-- 法定代表人证件类型 -->
                <el-form-item label="法定代表人证件类型：">
                    <span v-if="basicForm.personalCardType == 1">身份证</span>
                    <span v-if="basicForm.personalCardType == 2">护照</span>
                </el-form-item>

                <!-- 法定代表人身份证件电子版 -->
                <el-form-item label="法定代表人身份证件电子版：">
                    <div>
                        <img v-if="basicForm.personalCardFile" @click="previewPic($event)" class="pic_skan" :src="basicForm.personalCardFile">
                    </div>
                </el-form-item>
            </el-form>
            <!--预览图片-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img  width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    export default {
        data () {
            return {
                suppliersId: 0,

                categoryType: [],                               // 品类合作类型
                // 预览图片
                dialogImageUrl: '',
                dialogVisible: false,
                // 提交数据
                basicForm: {},

                records:[],

                control:{
                    loginType:0,
                    status:0,
                    view:0,
                    audit:0,
                    schedule:'',
                    content:''
                }
            }
        },
        methods: {
            initBasicInfo(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/detail',
                    data: {
                        suppliersId: suppliersId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.basicForm = result.data;

                            that.basicForm.categoryIsBook = result.data.categoryIsBook;
                            that.basicForm.categoryNotBook = result.data.categoryNotBook;
                            if (that.basicForm.categoryIsBook == 1 && that.basicForm.categoryNotBook == 1) {
                                that.categoryType = ["1","2"]
                            } else if (that.basicForm.categoryIsBook == 1 && that.basicForm.categoryNotBook == 0) {
                                that.categoryType = ["1"]
                            } else if (that.basicForm.categoryIsBook == 0 && that.basicForm.categoryNotBook == 1) {
                                that.categoryType = ["2"]
                            }
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            initControl(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/control',
                    data: {
                        suppliersId: suppliersId,
                        type:1
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.control = result.data;
                            that.initRecords(suppliersId);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            initRecords(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/currentRecord',
                    data: {
                        suppliersId: suppliersId,
                        type:1
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.records = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            deleteRecord(recordId,status){
                var that = this;

                var msg = status==1 ? '此操作将永久删除该记录, 是否继续?' : '此操作将取消审核申请, 是否继续?';

                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var that = this;
                    $.get({
                        url: '/suppliers/supplier/deleteRecord',
                        data: {
                            recordId: recordId
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.initRecords(result.data.suppliersId);
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

            editBasicInfoData(recordId) {
                this.$router.push({
                    path:'/supplier_basic_manage?recordId=' + recordId + '&backType=1'
                })
            },
        },

        mounted () {
            var suppliersId = this.$route.query.suppliersId;
            this.suppliersId = suppliersId;
            this.initBasicInfo(suppliersId);
            this.initControl(suppliersId);
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 91%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }

        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 87%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }

        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }

        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }

        .pic_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .form_color {
            color: rgb(106, 72, 77);
        }

        .el-form-item {
            margin-bottom: 0;
        }
</style>


// WEBPACK FOOTER //
// basicInfo.vue?34070f7e